import { render, staticRenderFns } from "./MessageNews.vue?vue&type=template&id=9176e8fa&scoped=true"
import script from "./MessageNews.vue?vue&type=script&lang=js"
export * from "./MessageNews.vue?vue&type=script&lang=js"
import style0 from "./MessageNews.vue?vue&type=style&index=0&id=9176e8fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9176e8fa",
  null
  
)

export default component.exports